import * as React from "react";
import {Icon} from "./Icon";

export class ActivePortalIcon extends Icon {

  render() {
    return <Icon {...this.props}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
          <polygon points="29.17 4.5 11.82 21.84 2.83 12.85 0 15.68 8.99 24.67 8.99 24.68 11.82 27.5 32 7.32 29.17 4.5"/>
        </svg>
      </Icon>;
  }
}
